import { useTranslation } from 'react-i18next'
import { NavLink } from 'react-router-dom'

import { NAVIGATION_LABELS } from '../../../helpers/constants'
import NavigationLabel from '../../NavigationLabel/NavigationLabel'

const WebsiteWidgetsLink = () => {
  const { t } = useTranslation(['navbar'])

  return (
    <div className="hover-menu-item">
      <NavLink
        className={({ isActive }) =>
          isActive ? 'navmgr-item__link--active' : 'hover-menu-item__link'
        }
        to="/dashboard/building-dashboard/website-widgets"
      >
        <span>
          {t('navbar:upsellingLinks.websiteWidgets')}
          <NavigationLabel locked={false} type={NAVIGATION_LABELS.NEW} />
        </span>
      </NavLink>
    </div>
  )
}

export default WebsiteWidgetsLink
